import { Navigate, RouteObject } from 'react-router';
import Loadable from '../components/Loadable';
import { lazy } from 'react';

const MetricsPage = Loadable(lazy(() => import('../connections/metrics/ConnectionMetricsPage')));
const MetricTemplatesPage = Loadable(lazy(() => import('../connections/metrics/MetricTemplates/MetricTemplatesPage')));
const ActivitiesPage = Loadable(lazy(() => import('../connections/activities/ConnectionActivitiesPage')));
const DataSourcesPage = Loadable(lazy(() => import('../connections/dataSources/ConnectionDataSourcesPage')));
const GoogleSheetsLayout = Loadable(lazy(() => import('../connections/dataSources/google/GoogleSheetsLayout')));
const LastUpdatesPage = Loadable(lazy(() => import('../connections/dataSources/google/LastUpdatesPage')));
const SourceDetailPage = Loadable(lazy(() => import('../connections/dataSources/google/SourceDetailPage')));

export const connectionRoutes: RouteObject[] = [
	{
		path: '',
		element: <Navigate to={'/connections/data-sources'} />,
	},
	{
		path: 'metrics',
		element: <MetricsPage />,
	},
	{
		path: 'metrics-templates',
		element: <MetricTemplatesPage />,
	},
	{
		path: 'activities',
		element: <ActivitiesPage />,
	},
	{
		path: 'data-sources',
		element: <DataSourcesPage />,
		children: [
			{
				path: 'google-sheets',
				element: <GoogleSheetsLayout />,
				children: [
					{
						path: '',
						element: <Navigate to={'/connections/data-sources/google-sheets/source-details'} />,
					},
					{
						path: 'source-details',
						element: <SourceDetailPage />,
					},
					{
						path: 'last-updates',
						element: <LastUpdatesPage />,
					},
				],
			},
		],
	},
];
